import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

type RegistrationOpenState = { open: boolean; isLoading: boolean };

export function useRegistrationOpen(): RegistrationOpenState {
  const { data, isLoading } = useQuery({
    queryKey: ['registration_open'],
    queryFn: async () => {
      try {
        const r = await pb.send('/api/registration/status', { method: 'GET' });
        return (r as { open?: boolean }).open !== false;
      } catch {
        return true;
      }
    },
    staleTime: 10_000,
    retry: 1,
  });
  return { open: data ?? true, isLoading };
}
